export default {
  calendarDates: {
    start: null,
    end: null,
    selected: 'Últimos 30 dias',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/calendar/initialState.js